var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('downloadexcel',{staticClass:"btn btn-success btn-sm",attrs:{"data":_vm.data,"fields":_vm.fields,"type":_vm.type}},[_vm._v(" "+_vm._s(_vm.title)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }